"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deprecated = void 0;
var messageMap = {};

var deprecated = function deprecated(message) {
  if (!messageMap[message]) {
    messageMap[message] = true; // eslint-disable-next-line no-console

    console.warn(message);
  }
};

exports.deprecated = deprecated;